<template>
  <section>
    <div class="area_pantalla">
      <div class="scroll_vertical">
        <div style="height: 10%"></div>

        <center>
          <div style="width: 77%; max-width: 400px">
            <img style="width: 80%; max-width: 300px" src="@/assets/logo_rackon2.svg" />

            <div class="mt-10 text-h6" style="color: #bead87">Registro</div>
            <v-form ref="form" v-on:submit.prevent v-model="permitirRegistro">
              <v-text-field
                class="mt-7"
                ref="nombre"
                label="Nombre completo"
                prepend-inner-icon="mdi-account"
                :rules="[rvValorNoVacio]"
                v-model="nombre"
                @keyup.enter="$refs.email.focus()"
              ></v-text-field>

              <v-text-field
                ref="email"
                label="Correo electrónico"
                prepend-inner-icon="mdi-email"
                :rules="[rvValorNoVacio, rvEmailValido]"
                validate-on-blur
                v-model="email"
                placeholder=" "
                @keyup.enter="$refs.contrasena.focus()"
              ></v-text-field>

              <v-text-field
                ref="contrasena"
                label="Contraseña"
                prepend-inner-icon="mdi-account-key"
                :rules="[rvValorNoVacio, rvPasswordValido]"
                validate-on-blur
                v-model="password"
                placeholder=" "
                :type="mostrarPassword ? 'text' : 'password'"
                :append-icon="mostrarPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="mostrarPassword = !mostrarPassword"
                @keyup="passwordModificado = true"
                @keyup.enter="$refs.confirmacionContrasena.focus()"
                :value="''"
              ></v-text-field>

              <v-text-field
                ref="confirmacionContrasena"
                label="Confirme la contraseña"
                prepend-inner-icon="mdi-lock-check"
                :rules="[rvValorNoVacio, rvPasswordsCoinciden]"
                v-model="confirmacionPassword"
                :type="mostrarConfirmacionPassword ? 'text' : 'password'"
                :append-icon="mostrarConfirmacionPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="mostrarConfirmacionPassword = !mostrarConfirmacionPassword"
                @focus="prepararCampoConfirmacionPassword()"
              ></v-text-field>

              <v-checkbox v-model="aceptoTerminosServicio" :rules="[rvValorNoVacio]">
                <template v-slot:label>
                  <div>
                    Acepto los
                    <router-link to="TOS">Terminos del servicio</router-link>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox
                class="mt-n2"
                v-model="aceptoPoliticaPrivacidad"
                :rules="[rvValorNoVacio]"
              >
                <template v-slot:label>
                  <div>
                    Acepto la
                    <router-link to="PPD">Política de privacidad</router-link>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox class="mt-n2" v-model="recibirPromociones">
                <template v-slot:label>
                  <div>Acepto recibir mensajes promocionales</div>
                </template>
              </v-checkbox>

              <v-btn
                class="mt-5"
                ref="registro"
                :disabled="!permitirRegistro"
                elevation="2"
                color="pink darken-4"
                @click="registro()"
              >Registrarse</v-btn>
            </v-form>

            <div v-if="$global.deviceInfo.platform != 'android'" class="mt-5">
              <router-link to="/" replace>Iniciar sesión</router-link>
            </div>
          </div>
        </center>

        <v-dialog v-model="cuadroEmergente.mostrar" max-width="400">
          <v-card light>
            <v-card-title class="headline"><v-icon color="#303030" x-large class="mr-2" v-html="cuadroEmergente.icono"></v-icon><span v-html="cuadroEmergente.titulo"></span></v-card-title>
            <v-card-text><span v-html="cuadroEmergente.texto"></span></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="cuadroEmergente.accion()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div style="height: 40px"></div>
      </div>
    </div>
  </section>
</template>

<script>
import * as Validadores from "@/validadores.js";
import {deshabilitarAutocompletado} from "@/util.js"
import api from '@/api';

export default {
  name: "Registro",
  data: () => ({
    permitirRegistro: false,
    nombre: "",
    email: "",
    password: "",
    confirmacionPassword: "",
    mostrarPassword: false,
    passwordModificado: false,
    mostrarConfirmacionPassword: false,
    aceptoTerminosServicio: false,
    aceptoPoliticaPrivacidad: false,
    recibirPromociones: false,
    cuadroEmergente: {
      mostrar: false,
      titulo: "",
      texto: "",
      accion: null
    },
    timer: null
  }),

  methods: {
    rvValorNoVacio(valor) {
      return Validadores.esValorNoVacio(valor) || "Requerido";
    },
    rvEmailValido(valor) {
      return Validadores.esEmailValido(valor) || "Email no válido";
    },
    rvPasswordValido(valor) {
      return valor.length > 5 || "Mínimo 6 caracteres";
    },
    rvPasswordsCoinciden(valor) {
      return valor == this.password || "Las contraseñas no coinciden";
    },

    prepararCampoConfirmacionPassword() {
      if (this.confirmacionPassword != "" && this.passwordModificado)
        this.confirmacionPassword = "";
      this.passwordModificado = false;
    },

    registro() {
      this.$global.cargando = true;
      api.registroUsuario (this.nombre, this.email, this.password, this.recibirPromociones, this.$store.state.tokenNotificaciones)
        .then (() => {
          this.cuadroEmergente.icono = "mdi-email-outline";
          this.cuadroEmergente.titulo = "Listo! Revisa tu correo";
          this.cuadroEmergente.texto = "Esta acción requiere una verificación de correo.<br>Por favor, revisa tu buzón de correo y sigue las instrucciones enviadas.<br>El correo fue enviado a <strong>" + this.email + "</strong>.";
          this.cuadroEmergente.mostrar = true;
          this.cuadroEmergente.accion = () => { this.cuadroEmergente.mostrar = false; this.$router.replace ("/"); };
        })
        .catch (e => {
          console.log(e);
          this.cuadroEmergente.icono = "mdi-alert-octagon-outline";
          this.cuadroEmergente.titulo = "Error al registrar usuario";
          this.cuadroEmergente.texto = e.response.data.error ? e.response.data.error : e;
          this.cuadroEmergente.mostrar = true;
          this.cuadroEmergente.accion = () => { this.cuadroEmergente.mostrar = false };
        })
        .finally (() => {
          this.$global.cargando = false;
        });
    }
  },
  mounted() {
    deshabilitarAutocompletado(this.$refs.form.$el);
    if (this.$global.deviceInfo.platform == "web") {      
      this.$refs.nombre.focus();      
    }
  }
};
</script>

<style scoped>
</style>